import { authorizedBillingFetch } from 'app/axios/billing'

export const createSetupIntents = (rootDomainId: string) =>
  authorizedBillingFetch.get(`/root-domain/${rootDomainId}/setupIntent`)

export interface InvoiceParams {
  promocode: string
  priceId: string
  quantity?: number
}

export const getInvoice = (
  params: InvoiceParams,
  homeId: string,
  rootDomainId: string
) =>
  authorizedBillingFetch.post(
    `root-domain/${rootDomainId}/home/${homeId}/invoices/upcoming`,
    params
  )
